export const SET_RECONCILE_USERS = 'SET_RECONCILE_USERS';
export const SET_BATCH_REPORT = 'SET_BATCH_REPORT';
export const SET_SELECTED_BATCHES = 'SET_SELECTED_BATCHES';
export const SET_SELECTED_REPORTS = 'SET_SELECTED_REPORTS';
export const SET_PAYMENT_BATCHES = 'SET_PAYMENT_BATCHES';
export const CLEAR_RECONCILE_PAYMENT_BATCH = "CLEAR_RECONCILE_PAYMENT_BATCH";
export const UPDATE_AMOUNT_ON_HAND = 'UPDATE_AMOUNT_ON_HAND';
export const SET_BATCH_INFO = 'SET_BATCH_INFO';
export const SET_BATCH_NUMBERS = 'SET_BATCH_NUMBERS';

const initialState = {
    users: [],
    batches: [],
    batchInfo: {},
    selectedBatches: [],
    batchReports: [],
    selectedReports: [],
    batchNums: [],
}

const ReconcileReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_RECONCILE_USERS:
            return {
                ...state,
                users: action.users
            }
        case SET_PAYMENT_BATCHES: 
            return {
                ...state,
                batches: action.batches.map(batch => {return {...batch, id: batch.ID}})
            }
        case SET_BATCH_REPORT:
            return {
                ...state,
                batchReports: action.batchReports
            }
        case SET_SELECTED_REPORTS: {
            return {
                ...state,
                selectedReports: action.selectedReports
            }
        }
        case SET_SELECTED_BATCHES:
            return {
                ...state,
                selectedBatches: action.selectedBatches
            }
        case CLEAR_RECONCILE_PAYMENT_BATCH: 
            return {
                ...state,
                users: initialState.users,
                batches: initialState.batches,
                selectedBatches: initialState.selectedBatches,
                batchReports: initialState.batchReports,
                batchInfo: initialState.batchInfo,
                batchNums: initialState.batchNums,
            };
        case UPDATE_AMOUNT_ON_HAND: {
            const { value, row } = action;
            let updatedInfo = [...state.batchInfo[row.batchTypeID]]
            updatedInfo.forEach((info) => {
                if (info.ID === row.ID) {
                    info.AmountOnHand = value;
                }
            })
            return {
                ...state,
                batchInfo: {
                    ...state.batchInfo,
                    [action.row.batchTypeID]: updatedInfo
                },
            }
        }
        case SET_BATCH_INFO: {
            const setBatchInfo = action.batchInfo.map(info => {
                return {
                    ...info,
                    id: info.ID,
                    //AmountOnHand: Number(info.Amount || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                }
            })
            return {
                ...state,
                batchInfo: {...state.batchInfo, [action.batchTypeID]: setBatchInfo}
            }
        }
        case SET_BATCH_NUMBERS: {
            return {
                ...state,
                batchNums: action.batchNums,
            }
        }
        default:
            return state;
    }
}

export default ReconcileReducer

